import { atKeys, notNullish, parseRecord } from "@de-xima/xima-common-js-lang";
import { toJQuery, type TElementSpecifier } from "@de-xima/xima-common-js-dom";
import $ from "jquery";

const CSS_CLASS_CARD = "card";
const CSS_CLASS_ROW = "content-panel-horizontal";

// Custom functions for the form overview page, ie. /ui/forms

/**
 * @param card Form card to select (card view).
 */
function selectCard(card: JQuery): void {
  const cards = card.closest("form").find(".card");
  cards.removeClass("ui-state-highlight");
  card.addClass("ui-state-highlight");
}

/**
 * @param row Form row to select (list view).
 */
function selectRow(row: JQuery) {
  const rows = row.closest("form").find(`.${CSS_CLASS_ROW}`);
  rows.removeClass("ui-state-highlight");
  row.addClass("ui-state-highlight");

  const visibles = toJQuery(rows.find(".col-visible.actionbar"));
  visibles.addClass("col-hidden");
  const hidden = toJQuery(row.find(".col-hidden.actionbar"));
  hidden.removeClass("col-hidden");
  hidden.addClass("col-visible");
}

/**
 * Selects the given (form) card or row. Optionally scrolls the card into view.
 * @param item Card (CSS class `.card`) or list item row (CSS class
 * `.content-panel-horizontal`) to be selected.
 * @param scrollInView If true, scroll to the given card.
 */
export function selectItem(item: TElementSpecifier<HTMLElement>, scrollInView: boolean = false): void {
  const $item = toJQuery(item).closest(`.${CSS_CLASS_CARD},.${CSS_CLASS_ROW}`);
  if ($item.length === 0) {
    return;
  }
  if ($item.hasClass(CSS_CLASS_CARD)) {
    selectCard($item);
  } else if ($item.hasClass(CSS_CLASS_ROW)) {
    selectRow($item);
  }
  if (scrollInView && $item !== undefined && $item.length > 0) {
    const list = $item.closest(".xfc-project-list-scrollable-container");
    if (list.length === 1) {
      const offset = $item.offset();
      if (offset !== undefined) {
        list.animate({ scrollTop: offset.top - 150 }, 500);
      }
    }
  }
}

/**
 * Selects the given (form) card or row. Optionally scrolls the card into view.
 * @param pid Project ID of the form to be selected.
 * @param scrollIntoView If true, scroll to the card of the given proejct.
 */
export function selectItemByPid(pid: string | number | undefined, scrollIntoView: boolean = false): void {
  if (notNullish(pid) && pid !== "") {
    const $item = $(`.card.project-id-${pid},.xfc-project-list-item.project-id-${pid}`);
    selectItem($item, scrollIntoView);
  }
}

/**
 * Updates the project list and selects the project with the given pid.
 * @deprecated Refactor to web sockets
 * @param pid Project ID of the form to be selected.
 */
export function updateProjectListOfOpener(pid?: string | number): void {
  try {
    const ourOpener = parseRecord(window.opener);
    if (typeof ourOpener.updateListAndGoToSelected === "function") {
      ourOpener.updateListAndGoToSelected([{ name: "pid", value: pid }]);
    }
    const parentOpener = parseRecord(atKeys(window, ["parent", "opener"]));
    if (typeof parentOpener.updateListAndGoToSelected === "function") {
      parentOpener.updateListAndGoToSelected([{ name: "pid", value: pid }]);
    }
  } catch {
    // ignore, usually occurs when trying to access a cross-origin frame
    // This may happen when the parent window still exists, but was navigated
    // to another URL.
  }
}

/**
 * Toggles the up/down arrow icons of the group header, and hides all group
 * items that should not be displayed.
 * @param element Element that toggled the header.
 */
export function onToggleGroupHeader(element: TElementSpecifier<HTMLElement>): void {
  const $el = toJQuery(element);

  const header = $el.closest(".xfc-header-row");
  for (const groupItem of $(header).nextUntil(".xfc-header-row")) {
    $(groupItem).toggleClass("Hidden");
  }
  let $btn: JQuery;
  if (!$el.hasClass("header-row-button")) {
    $btn = $el.parent().find(".header-row-button");
  } else {
    $btn = $el;
  }
  if ($btn.hasClass("fa-chevron-down")) {
    $btn.removeClass("fa-chevron-down");
    $btn.addClass("fa-chevron-right");
  } else if ($btn.hasClass("fa-chevron-right")) {
    $btn.removeClass("fa-chevron-right");
    $btn.addClass("fa-chevron-down");
  }
}
